module.exports = __webpack_public_path__ + "4e334453b9b349270836d2a887aab31b.svg";